﻿export const REDUCE_CLIENT_ELEMENT = 'REDUCE_CLIENT_ELEMENT';
export const REDUCE_CLIENT = 'REDUCE_CLIENT';
export const REDUCE_CLIENT_POLICIES = 'REDUCE_CLIENT_POLICIES';
export const GET_CLIENT = 'GET_CLIENT';
export const GET_CLIENT_POLICIES = 'GET_CLIENT_POLICIES';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const QUERY_CLIENTS = 'QUERY_CLIENTS';
export const QUERY_CLIENT_REFS = 'QUERY_CLIENT_REFS';
export const EXECUTE_CLIENT_ACTION = 'EXECUTE_CLIENT_ACTION';
export const REDUCE_QUERY_ELEMENT = 'REDUCE_CLIENT_QUERY_ELEMENT';
export const REDUCE_CLIENTS = 'REDUCE_CLIENTS';
export const REDUCE_CLIENT_REFS = 'REDUCE_CLIENT_REFS';
export const REDUCE_ENTITY = 'REDUCE_ENTITY';
export const REDUCE_PARAMETERS = 'REDUCE_PARAMETERS';
export const REDUCE_PARAMETER = 'REDUCE_PARAMETER';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const REDUCE_NOTIFICATION = 'REDUCE_NOTIFICATION';
export const REDUCE_CLIENT_CUSTOM_INFO = 'REDUCE_CLIENT_CUSTOM_INFO';
export const GET_CLIENT_CUSTOM_INFO = 'GET_CLIENT_CUSTOM_INFO';
export const UPSERT_CLIENT_CUSTOM_INFO = 'UPSERT_CLIENT_CUSTOM_INFO';
export const REDUCE_CLIENT_CUSTOM_INFO_ELEMENT = 'REDUCE_CLIENT_CUSTOM_INFO_ELEMENT';
export const REDUCE_CLIENTS_MORTGAGE_DTOS = 'REDUCE_CLIENTS_MORTGAGE_DTOS';
export const GET_LOGS = 'GET_LOGS';
export const GET_LOG_CONTENT = 'GET_LOG_CONTENT';
export const REDUCE_CLIENT_LOGS = 'REDUCE_CLIENT_LOGS';
export const REDUCE_CLIENT_LOG_CONTENT = 'REDUCE_CLIENT_LOG_CONTENT';
export const QUERY_APPRAISALS = 'QUERY_APPRAISALS';
export const REDUCE_APPRAISALS = 'REDUCE_APPRAISALS';
export const REDUCE_APPRAISAL_QUERY_ELEMENT = 'REDUCE_APPRAISAL_QUERY_ELEMENT';
export const GET_APPRAISAL = 'GET_APPRAISAL';
export const REDUCE_APPRAISAL = 'REDUCE_APPRAISAL';
export const ASSOCIATE_CLIENT = 'ASSOCIATE_CLIENT';
export const GET_APPRAISAL_CLIENTS = 'GET_APPRAISAL_CLIENTS';
export const REDUCE_APPRAISAL_CLIENTS = 'REDUCE_APPRAISAL_CLIENTS';
export const APPROVE_CLIENT_ENTERED_HOME_VALUE = 'APPROVE_CLIENT_ENTERED_HOME_VALUE';

// Velocity Info
export const GET_VELOCITY_INFO = 'GET_VELOCITY_INFO';
export const REDUCE_VELOCITY_INFO = 'REDUCE_VELOCITY_INFO';
export const REDUCE_VELOCITY_INFO_ELEMENT = 'REDUCE_VELOCITY_INFO_ELEMENT';
export const UPDATE_VELOCITY_INFO = 'UPDATE_VELOCITY_INFO';
